// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"WhatsappPhoneNumberTable_headerCell__vUyLe","bodyCell":"WhatsappPhoneNumberTable_bodyCell__2dtka"};